import React, { useEffect } from 'react';
import { logger } from '../helpers/LoggerHelper';
import './LinkGenerator.css';
import { TranslationKeys } from '../configuration/IConfiguration';
import { translationsHelper } from '../helpers/TranslationsHelper';
import { ApplicationContext, ApplicationActionType } from '../context/ApplicationContext';
import { joinLinkRetriever } from '../helpers/JoinLinkRetriever';
import {Button} from '@skype/bew-components/dist/Button/Button';
import ShareJoinlinkDropdownButton from './ShareJoinlinkDropdownButton';
import config from '../config'
import JoinLinkTextBox from './JoinLinkTextBox'
import {Spinner} from '@skype/bew-components/dist/Loading/Spinner'
import { resizeReporter } from '../helpers/ResizeReporter';
import { browser, Browsers } from '../helpers/EnvironmentHelper';

const LinkGenerator: React.FC = () => {
  enum UiState {
    Intial,
    GeneratingLink,
    LinkGeneratedSuccess,
    FailedToGenerateLink
  }

  const { state, dispatch } = React.useContext(ApplicationContext);
  const [errorMessage, setErrorMessage] = React.useState("");

  // eslint-disable-next-line
  const [linkGenerationInProgress, setLinkGenerationInProgress] = React.useState(false);
  const [uiState, setUiState] = React.useState(UiState.Intial);

  useEffect(() => {
    resizeReporter.report();
    if (uiState === UiState.GeneratingLink && browser === Browsers.Safari) {
        const spinnerElement = document.getElementsByClassName('spinner')[0];
        if (spinnerElement) {
          spinnerElement.classList.add('no-animation');
          setTimeout(() => {
            spinnerElement.classList.remove('no-animation');
          }, 0);
        }
    }
  },[uiState, UiState.GeneratingLink]);

  const generateJoinLink = async () => {
    setUiState(UiState.GeneratingLink);
    setErrorMessage('');
    logger.ClickedOnGenerateJoinLinkButton();

    if (state.UserSkypeToken) {
      setLinkGenerationInProgress(true);
      let skypeUserJoinLink = await joinLinkRetriever.getJoinLinkForSkypeUser(state.UserSkypeToken);
      setLinkGenerationInProgress(false);
      if (skypeUserJoinLink.IsSuccess) {
        dispatch({
          Action: ApplicationActionType.JoinLinkCreationFinished,
          Payload: skypeUserJoinLink.JoinLink
         });
         setUiState(UiState.LinkGeneratedSuccess);
      }
      else {
        if (skypeUserJoinLink.ErrorMessage) {
          setErrorMessage(skypeUserJoinLink.ErrorMessage);
        }
        setUiState(UiState.FailedToGenerateLink);
      }
    }
    else {
      setLinkGenerationInProgress(true);
      let guestUserJoinLink = await joinLinkRetriever.getJoinLinkForGuestUser();
      setLinkGenerationInProgress(false);
      if (guestUserJoinLink.IsSuccess) {
        dispatch({
          Action: ApplicationActionType.JoinLinkCreationFinished,
          Payload: guestUserJoinLink.JoinLink
         });
         setUiState(UiState.LinkGeneratedSuccess);         
      }
      else {
        if (guestUserJoinLink.ErrorMessage) {
          setErrorMessage(guestUserJoinLink.ErrorMessage);
        }
        setUiState(UiState.FailedToGenerateLink);
      }
    }
  };

  const goToGeneratedMeeting = () => {
    logger.ClickedOnGoToGeneratedMeetingButton();
    if (state.LatestJoinLink) {
      window.top.location.href = state.LatestJoinLink;
    }
  };

  const logo = `${config.ecs.cdnHost}/assets/v3/Title@2x.png`
  const RenderHeader = () => {
    switch (uiState) {
      case UiState.Intial:
      case UiState.FailedToGenerateLink:
        return <div className="initialHeader">
          <img className="headerLogo" src={logo} alt={translationsHelper.GetTranslation(TranslationKeys.share_logo_alt_title)} />
          <p className="headerText">{translationsHelper.GetTranslation(TranslationKeys.main_title)}</p>
        </div>;
      case UiState.GeneratingLink:
        return <div>
        <div className="linkGeneratorSpinnerContainer">
          <Spinner size={80}/>
          </div>
          <div className="initialHeader">
            <p className="headerText">
            {translationsHelper.GetTranslation(TranslationKeys.generate_link_button_title_while_generating)}
            </p>
          </div>
          </div>;
      case UiState.LinkGeneratedSuccess:
          return <div className="generatedHeader">
          <img className="headerLogo" src={logo} alt={translationsHelper.GetTranslation(TranslationKeys.share_logo_alt_title)} /> 
          <p className="headerText">{translationsHelper.GetTranslation(TranslationKeys.main_title)}</p>
        </div>;
    }
  };

  return (
    <div className="linkGenerator">

      {RenderHeader()}

      { uiState === UiState.LinkGeneratedSuccess && <JoinLinkTextBox /> }

      { (uiState === UiState.Intial || uiState === UiState.FailedToGenerateLink) &&
        <div className="generateButtonHolder">
        <Button onClick={generateJoinLink} className="linkGeneratorButton  meetButton">
          {translationsHelper.GetTranslation(TranslationKeys.generate_link_button_title) }
        </Button>
        </div>
      }

      <div className="linkActionButtons">
      { (uiState === UiState.LinkGeneratedSuccess) &&
        <ShareJoinlinkDropdownButton />
      }

      <div>
      { (uiState === UiState.LinkGeneratedSuccess) &&
        <Button onClick={goToGeneratedMeeting} kind="primary" className="startCallButton" style={{backgroundColor: 'white'}}>
          <span className="cameraIcon">&#xE911;  </span><span className="startCallButtonText">{translationsHelper.GetTranslation(TranslationKeys.start_call_button_title)}</span>
        </Button>
      }
      </div>
      
      </div>

      <div className="errorMessage">{errorMessage}</div>
    </div>
  );
}

export default LinkGenerator;
